/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useState} from 'react';
import {NotificationPanel} from '@ion/applications/src/notifications/NotificationPanel';
import {ToastNotificationsContainer} from '@ion/applications/src/notifications/ToastNotificationsContainer';

export enum MenuItemKeys {
  Export = 'Export',
  Filter = 'Filter',
  Reset = 'Reset'
};

/**
 * @ToastNotificationWrapper
 *
 * Defines a component to display Notification Panel and Toast notification Container.
 *
 * ```typescript
 *   import ToastNotificationWrapper from '@ion/packages/ion-ctc-admin/src/header/ToastNotificationWrapper';
 *
 *   <ToastNotificationWrapper />;
 *
 * ```
 */
const ToastNotificationWrapper = () => {
  const [cancelToastDismiss, setCancelToastDismiss] = useState([]);
  return (
    <>
      <NotificationPanel omittedMenuItems={MenuItemKeys}
        cancelToastDismiss={cancelToastDismiss}
        setCancelToastDismiss={setCancelToastDismiss} />
      <ToastNotificationsContainer cancelToastDismiss={cancelToastDismiss}
        setCancelToastDismiss={setCancelToastDismiss} />
    </>
  );
};

export default React.memo(ToastNotificationWrapper);
